// 支援班表
import * as types from '../actionType';

let initState = {
  events: [],
  eventStartTime: "2018-11-01T00:00:00",
  eventEndTime: "2018-11-15T00:00:00"
};;

function supportScheduleShiftState(state = initState, action) {
  switch (action.type) {
      case types.SUPPORT_SCHEDULE_SHIFT_SUCCESS: {
        return action.result;
      }
      default:
        return state;
  }
}


export default supportScheduleShiftState;